/// <reference path="../../../../../typings/index.d.ts" />
declare module moment {
    interface Moment {
        getHoursAmPm(): number;
        getAmPm(): string;
        totalMinutes(): number;
        isInPast(): boolean;
        getFullYear(): number;
        time(): Moment;
        meevoFormat(f): string;
    }
}

interface String {
    foo(): number;
    escapeHtml(): string;
    toBoolean(): boolean;
    replaceAll(find: any, replaceWith: any): any;
}

interface Date {
    getHoursAmPm(): number;
    getAmPm(): string;
}

String.prototype.replaceAll = function (find, replaceWith) {
    return this.replace(new RegExp(find, 'g'), replaceWith);
};

String.prototype.escapeHtml = function () {
    return this.replaceAll("<", "&lt;").replaceAll(">", "&gt;");
};

String.prototype.toBoolean = function () {
    switch (this.toLowerCase()) {
        case "true": case "yes": case "1": return true;
        case "false": case "no": case "0": case null: return false;
        default: return Boolean(this);
    }
}

Date.prototype.getHoursAmPm = function () {
    var hours = this.getHours();
    if (hours == 0) {
        return 12;
    } else if (hours > 12) {
        return hours - 12;
    } else {
        return hours;
    }
}

Date.prototype.getAmPm = function () {
    if (this.getHours() < 12) {
        return "AM";
    } else {
        return "PM";
    }
}

moment.fn.getHoursAmPm = function () {
    var hours = this.hours();
    if (hours == 0) {
        return 12;
    } else if (hours > 12) {
        return hours - 12;
    } else {
        return hours;
    }
}

moment.fn.time = function () {
    return moment(this.format("HH:mm:ss"), "HH:mm:ss");
}

moment.fn.getAmPm = function () {
    if (this.hours() < 12) {
        return "AM";
    } else {
        return "PM";
    }
}

moment.fn.totalMinutes = function () {
    return this.hours() * 60 + this.minutes();
}

moment.fn.isInPast = function () {
    return moment().isAfter(this, 'd');
}

moment.fn.getFullYear = function () {
    console.log(this.year);
    return this.year;
}

moment.fn.meevoFormat = function (f) {

    let localeFormat = moment.localeData().longDateFormat('L');
    if (!moment(this).isValid()) {
        return;
    }
    let format;
    switch (f) {
        case 'L':
            format = this.format(moment.localeData().longDateFormat('L').replace('YYYY', 'YY'));
            break;
        case 'LL':
            format = this.format(moment.localeData().longDateFormat('LL').replace('YYYY', 'YY'));
            break;
        case 'LLL':
            format = this.format(moment.localeData().longDateFormat('LLL').replace('YYYY', 'YY'));
            break;
        case 'LLLL':
            format = this.format(moment.localeData().longDateFormat('LLLL').replace('YYYY', 'YY'));
            break;
        default:
            format = this.format();
    }
    return format;
}